__turbopack_context__.v({
  "bazaarvoice-review-terms-modal": "bazaarvoice-review-terms-modal-component-module-scss-module__aahIhq__bazaarvoice-review-terms-modal",
  "bazaarvoice-review-terms-modal__body": "bazaarvoice-review-terms-modal-component-module-scss-module__aahIhq__bazaarvoice-review-terms-modal__body",
  "bazaarvoice-review-terms-modal__section-headline": "bazaarvoice-review-terms-modal-component-module-scss-module__aahIhq__bazaarvoice-review-terms-modal__section-headline",
});
